import { Component } from '@angular/core';
import { LoadingService, LoadingState } from '@uigy/shared/services/loading.service';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    standalone: false
})
export class MainLayoutComponent {
  public LoadingState = LoadingState;

  constructor(public loadingService: LoadingService) {
  }
}
